export default "__VITE_ASSET__DZRNdTAI__"